jQuery(function($) {
	const base = "gp-cart";
	const date = $(`.${base}__date`);

	$(`.${base} input[name=frequency_type]`).on('change',function() {
		// reset state
		$(`.${base}__frequency`).addClass(`${base}__frequency--hidden`);

		if ($(this).val() == 'recurrent') {
			$(`.${base}__frequency`).removeClass(`${base}__frequency--hidden`);
			$(`.${base}__pickup-date`).addClass(`${base}__aside-section--hidden`);
		} else {
			$(`.${base}__pickup-date`).removeClass(`${base}__aside-section--hidden`);	
		}
	});

	$(`.${base} input[name=frequency]`).on('change',function() {
		// reset state
		$(`.${base}__days`).addClass(`${base}__days--hidden`);
		$(`.${base}__weeks`).addClass(`${base}__weeks--hidden`);

		const value = $(this).val();
		$(`#${base}__${value}-days`).removeClass(`${base}__days--hidden`);
		$(`#${base}__${value}-weeks`).removeClass(`${base}__weeks--hidden`);
	});

	function date_error() {
		date.addClass(`${base}__date--error`);
		$(`.${base}__date--error`).on('change',function() {
			$(`.${base}__date--error`).removeClass(`${base}__date--error`);
		});
		date.trigger('focus');
	}

	$(`.${base}__send`).on('click',function(e) {
		let date_is_not_in_past = false;
		
		$(`.${base}__alert`).hide();

		if ($(`.${base} input[name=frequency_type]:checked`).val() == 'one_time') {
			if ($(`.gp-cart__date`).val()) {
				let date_order = new Date($(`.gp-cart__date`).val());
				const date_now = Date.now();
				date_is_not_in_past = date_order > date_now;
			} else {
				return date_error();
			}

			if (!date_is_not_in_past) {
				return date_error();
			}
		}
	
		$(this).prop('disabled', true);
		fetch('/wp-json/growl/cart/placeOrder', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ 
				date: date.val(),
				comments: $(`.${base}__comment`).val(),
				frequency_type: $(`input[name=frequency_type]:checked`).val(),
				frequency: $(`input[name=frequency]:checked`).val(),
				week_day: $(`input[name=week_day]:checked`).val(),
				month_day: $(`input[name=month_day]:checked`).val(),
				month_week: $(`input[name=month_week]:checked`).val()
			}),
		})
		.then((response) => response.json())
		.then(response => {
			$(this).prop('disabled', false);
			
			if(response.success == true) {
				purgeCartParameters();
				window.location = '/my-account-current-orders/';
			} else {
				$(`.${base}__alert`).html(response.message).show();
			}
		})
	});

	function loadCartParameters() {
		const parameters = JSON.parse(localStorage.getItem('cartParameters'));
		if (parameters) {
			$('.gp-cart__date').val(parameters.date);
			$(`input[value=${parameters.frequency_type}]`).prop('checked', true).trigger('change');
			$(`input[value=${parameters.frequency}]`).prop('checked', true).trigger('change');
			$(`input[name=week_day][value=${parameters.week_day}]`).prop('checked', true).trigger('change');
			$(`input[name=month_day][value=${parameters.month_day}]`).prop('checked', true).trigger('change');
			$(`input[name=month_week][value=${parameters.month_week}]`).prop('checked', true).trigger('change');
			$('textarea[name=comment]').val(parameters.comment);
		}
	}

	loadCartParameters();

	function saveCartParameters() {
		const parameters = {
			'date' : $('.gp-cart__date').val(),
			'frequency_type' : $('input[name=frequency_type]:checked').val(),
			'frequency' : $('input[name=frequency]:checked').val(),
			'week_day' : $('input[name=week_day]:checked').val(),
			'month_day' : $('input[name=month_day]:checked').val(),
			'month_week' : $('input[name=month_week]:checked').val(),
			'comment' : $('textarea[name=comment]').val()
		}
	
		localStorage.setItem('cartParameters', JSON.stringify(parameters));
	}

	$(`.${base}__date`).on('change', function() 						{ 	saveCartParameters();	});
	$(`.${base} input[name=frequency_type]`).on('change', function() 	{ 	saveCartParameters();	});
	$(`.${base} input[name=frequency]`).on("change", function () 		{	saveCartParameters();	});
	$(`.${base} input[name=week_day]`).on("change", function () 		{	saveCartParameters();	});
	$(`.${base} input[name=month_day]`).on("change", function () 		{	saveCartParameters();	});
	$(`.${base} input[name=month_week]`).on("change", function () 		{	saveCartParameters();	});
	$(`.${base}__comment`).on('change', function() 						{ 	saveCartParameters();	});

	function purgeCartParameters() {
		localStorage.removeItem('cartParameters');
	}
});